export const CHANGE_FACILITY = 'CHANGE_FACILITY';
export const CHANGE_MEDICATION = 'CHANGE_MEDICATION';
export const CHANGE_PATIENT = 'CHANGE_PATIENT';
export const CHANGE_PREPARATION_DATE = 'CHANGE_PREPARATION_DATE';
export const CHANGE_VERIFIER = 'CHANGE_VERIFIER';
export const TOGGLE_INFUSION_TIME_OVERRIDE = 'TOGGLE_INFUSION_TIME_OVERRIDE';
export const TOGGLE_MEDICATION = 'TOGGLE_MEDICATION';
